import styled from "styled-components";

import { HEADER_HEIGHT } from "constants/layout";

export const ContentWrapper = styled.div`
  position: relative;

  flex-grow: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  min-width: 1000px;

  box-sizing: border-box;
`;

export const WrappedContainer = styled.div`
  display: flex;

  width: 100%;
  height: 100%;
  min-height: 100%;

  padding-top: ${HEADER_HEIGHT};

  box-sizing: border-box;
`;
